module.exports = __webpack_public_path__ + "img/metal_ba@2x.bafa1286.png";